import { useLang } from '@/i18n';
import EfFooterTc from '@elem/ui/ef-footer-tc';
import EfSpec from '@elem/ui/ef-spec';
import { useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.FootTC');
    const [list, setList] = useState<any[]>([
        {
            isHeader: true,
            title: t('title'),
        },
        {
            title: t('desc_1'),
        },
        {
            title: t('desc_2'),
        },
        {
            title: t('desc_3'),
        },
        {
            title: t('desc_4'),
        },
    ]);

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfFooterTc list={list} />
            <EfSpec />
        </div>
    );
}
